import React from 'react';
import TablePagination from '@mui/material/TablePagination';
import useDictionary from '@ui/hooks/useDictionary';
import {
    IProps as IMainProps,
    IClasses as IMainClasses,
} from './Footer.component';

interface IClasses
    extends Pick<
        IMainClasses,
        | 'tablePagination'
        | 'tablePaginationActions'
        | 'tablePaginationRowsLabel'
        | 'tablePaginationSelectLabel'
    > {}

interface IProps
    extends Pick<
        IMainProps,
        'lang' | 'page' | 'limit' | 'dataLength' | 'onPageChange'
    > {
    classes?: IClasses;
}

interface IRow {
    from: unknown;
    to: unknown;
    count: unknown;
}

const Component: React.FC<IProps> = ({
    classes,
    page,
    limit,
    dataLength,
    onPageChange,
}: IProps) => {
    const getWord = useDictionary();
    if (dataLength) {
        const labelDisplayedRows = ({ from, to, count }: IRow) => {
            return `${from}-${to} ${getWord('of').toLowerCase()} ${count}`;
        };

        return (
            <>
                <TablePagination
                    classes={{
                        root:
                            classes?.tablePagination ??
                            'telemetry__table-pagination',
                        actions:
                            classes?.tablePaginationActions ??
                            'telemetry__table-pagination-actions',
                        displayedRows:
                            classes?.tablePaginationRowsLabel ??
                            'telemetry__table-pagination-rows-label',
                        selectLabel:
                            classes?.tablePaginationSelectLabel ??
                            'telemetry__table-pagination-select-label',
                    }}
                    page={page}
                    onPageChange={onPageChange}
                    rowsPerPage={limit}
                    count={dataLength}
                    labelDisplayedRows={labelDisplayedRows}
                    rowsPerPageOptions={[]}
                />
            </>
        );
    } else return <></>;
};

const PaginationComponent = React.memo(Component);

export default PaginationComponent;
